import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import AdminAuthRoute from '../../components/AdminAuthRoute';
import { AdminLogin } from './auth/AdminLogin';
import { AdminLayout } from './layout/AdminLayout';
import { BenefitForm } from './benefits/BenefitForm';
import { BenefitManage } from './benefits/BenefitManage';
import { DictManage } from './dicts/DictManage';
import { MenuManage } from './menus/MenuManage';
import { PackageDetail } from './packages/PackageDetail';
import { PackageForm } from './packages/PackageForm';
import { PackageManage } from './packages/PackageManage';
import { OrderManage } from './orders/OrderManage';
import { PermissionGroupManage } from './permissionGroups/PermissionGroupManage';
import { PermissionManage } from './permissions/PermissionManage';
import { UserManage } from './users/UserManage';

/** 管理端路由组，统一 `/devops/creator-outreach` 前缀。 */
export const adminRoutes = (
  <>
    <Route path='/devops/creator-outreach/login' element={<AdminLogin />} />
    <Route
      path='/devops/creator-outreach'
      element={
        <AdminAuthRoute>
          <AdminLayout />
        </AdminAuthRoute>
      }
    >
      <Route index element={<Navigate to='users' replace />} />
      <Route path='users' element={<UserManage />} />
      <Route path='permissions' element={<PermissionManage />} />
      <Route path='permission-groups' element={<PermissionGroupManage />} />
      <Route path='packages' element={<PackageManage />} />
      <Route path='packages/new' element={<PackageForm />} />
      <Route path='packages/:planCode/edit' element={<PackageForm />} />
      <Route path='packages/:planCode' element={<PackageDetail />} />
      <Route path='benefits' element={<BenefitManage />} />
      <Route path='benefits/new' element={<BenefitForm />} />
      <Route path='orders' element={<OrderManage />} />
      <Route path='dicts' element={<DictManage />} />
      <Route path='menus' element={<MenuManage />} />
    </Route>
  </>
);
